import { useBreakpointValue } from "@gemini/core";

import { BottomCustomBanner } from "./variants/BottomCustomBanner";
import { PersistentCustomBanner } from "./variants/PersistentCustomBanner";
import { useCustomBanner } from "./useCustomBanner";

const componentByVariant = {
  bottom: BottomCustomBanner,
  persistent: PersistentCustomBanner,
};

export const CustomBanner = () => {
  const isSmallViewport = useBreakpointValue({
    base: true,
    md: false,
  });

  const variant = isSmallViewport ? "bottom" : "persistent";

  const { bannerInfo, isBannerVisible, onClick, onDismiss } = useCustomBanner({
    variant,
  });

  if (isBannerVisible === null || !bannerInfo) return null;

  const CustomBannerComponent = componentByVariant[variant];

  return (
    <CustomBannerComponent
      bannerInfo={bannerInfo}
      isBannerVisible={isBannerVisible}
      onClick={onClick}
      onDismiss={onDismiss}
    />
  );
};
